import Validator from 'js-object-validation';
import { message } from '../common';
import { replaceAll } from '../helpers';

export const categoryValidator = data => {
  const validations = {
    categoryName: {
      required: true,
      maxlength: 30,
    },
  };
  // Error messages
  const messages = {
    categoryName: {
      required: message.Required.replace(':item', 'Category name'),
      maxlength: replaceAll(message.MaxLengthError, {
        ':item': 'Category name',
        ':length': 30,
      }),
    },
  };

  const { isValid, errors } = Validator(data, validations, messages);
  return {
    isValid,
    errors,
  };
};
